/* This file is autogenerated, see readme.md for instructions */
import ArchiveSvgIcon from '@bloomreach/banana-theme/icons/archive.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArchiveIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArchiveSvgIcon />
    </Icon>
  );
});

ArchiveIcon.displayName = 'ArchiveIcon';

export default ArchiveIcon;
